// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 636) return "js/frontend/636.js";
	if (chunkId === 714) return "js/frontend/714.js";
	if (chunkId === 698) return "js/frontend/698.js";
	if (chunkId === 927) return "js/frontend/927.js";
	// return url for filenames based on template
	return undefined;
};